var map = {
	"./canon/cover.jpg": "QCjM",
	"./canon/main.jpg": "OGOT",
	"./canon/ux.jpg": "uwKF",
	"./chinese-fonts/cover.jpg": "O0To",
	"./cloudnifier/cover.jpg": "vv4A",
	"./disenyland/cover.jpg": "GWQV",
	"./drawing/pinky.jpg": "Lazi",
	"./drawing/propic-line.png": "EjA0",
	"./drawing/propic.png": "ffvQ",
	"./dtc/dashboard.jpg": "kxZM",
	"./dtc/project.jpg": "mgRi",
	"./eventor/banner1.jpg": "HjJ8",
	"./eventor/banner2.jpg": "HDeu",
	"./eventor/ux.jpg": "wgy/",
	"./glassesgallery/content.jpg": "5FwO",
	"./glassesgallery/cover.jpg": "OL8e",
	"./glassesgallery/list.jpg": "MhaO",
	"./hatchya/banner.jpg": "M95u",
	"./hatchya/card.jpg": "149w",
	"./hatchya/infographic.jpg": "ttFu",
	"./hatchya/infographic2.jpg": "1h50",
	"./hatchya/login.jpg": "gYFG",
	"./management/dashboard.jpg": "lRq9",
	"./management/floorplan.jpg": "93nI",
	"./management/login.jpg": "iZYo",
	"./management/request.jpg": "hnXK",
	"./merchant-plus/collection.jpg": "iNIn",
	"./merchant-plus/collection2.jpg": "KdqL",
	"./merchant-plus/login.jpg": "djIF",
	"./merchant-plus/mobile.jpg": "gJL2",
	"./student-smart/bookmark.jpg": "G/Zm",
	"./student-smart/bookmark2.jpg": "A418",
	"./student-smart/circle.png": "qgFt",
	"./student-smart/comment.png": "tQKA",
	"./student-smart/profile.png": "X/Eb",
	"./student-smart/score.png": "C7MC",
	"./student-smart/student.png": "bqfK",
	"./svg-morpheus/cover.jpg": "cUoY",
	"./swisscoat/blog.jpg": "kNH2",
	"./swisscoat/index.jpg": "bwqR",
	"./swisscoat/lens.jpg": "JJb3",
	"./swisscoat/sim.jpg": "UcYB",
	"./swisscoat/test.jpg": "DpCX",
	"./vtour/VTour01.png": "OjpB",
	"./vtour/home.png": "0lwl"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Hnub";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects ^\.\/.*$
// module id = Hnub
// module chunks = 1